import { useEffect } from 'react';
import {
  isVinylMusicDelivery,
  playVinylMusic,
  stopVinylMusic,
} from '../../assets/preloadSounds';
import {
  createSuccessDeliveryScreenModel,
  type SuccessDeliveryScreenProps,
} from './SuccessDeliveryScreenModelScreen';
import { SuccessDeliveryScreenController } from './SuccessDeliveryScreenController';
import { SuccessDeliveryScreenView } from './SuccessDeliveryScreenView';
import { usePlaySoundOnMount } from '../../hooks/usePlaySoundOnMount';

export type { SuccessDeliveryScreenProps } from './SuccessDeliveryScreenModelScreen';

export function SuccessDeliveryScreen(props: SuccessDeliveryScreenProps) {
  usePlaySoundOnMount('delivery.success');
  const model = createSuccessDeliveryScreenModel(props);
  const isVinyl = isVinylMusicDelivery(model.giantId, model.orderIndex);

  useEffect(() => {
    if (!isVinyl) {
      return;
    }
    playVinylMusic();
    return () => {
      stopVinylMusic();
    };
  }, [isVinyl]);

  const controller = new SuccessDeliveryScreenController(model);

  return <SuccessDeliveryScreenView model={model} controller={controller} />;
}
